import {
  StaticScreen,
  StaticScreenContent,
  StaticScreenTitle,
} from 'src/components/StaticScreen/StaticScreen'

export const CompleteDocuSignAction: React.FC = () => {
  return (
    <StaticScreen colorScheme="green">
      <StaticScreenTitle>フォームの送信が完了しました。</StaticScreenTitle>
      <StaticScreenContent>
        ブラウザのタブを閉じてください。
      </StaticScreenContent>
    </StaticScreen>
  )
}
